/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Header_SubtitleInputs */

const es_billing_header_subtitle = /** @type {(inputs: Billing_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de consumo, costos y facturación`)
};

const en_billing_header_subtitle = /** @type {(inputs: Billing_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage, costs and billing overview`)
};

/**
* | output |
* | --- |
* | "Usage, costs and billing overview" |
*
* @param {Billing_Header_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_header_subtitle = /** @type {((inputs?: Billing_Header_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Header_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_header_subtitle(inputs)
	return en_billing_header_subtitle(inputs)
});
export { billing_header_subtitle as "billing.header.subtitle" }